import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../../types'
import { fetchShift, type FetchShiftOptions } from '../shift.api'
import { shiftApiCacheKeys } from '../shift.api.cacheKeys'
import type { ShiftRQSchema } from '../types/Shift.schema'

export const useFetchShift = (
  request: FetchShiftOptions,
  queryOptions?: UseAppQueryOptions<ShiftRQSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: shiftApiCacheKeys.get(request.pathParams),
    queryFn: () => fetchShift(request)
  })
}
